import React from 'react'
import Card from 'react-bootstrap/Card'
// import {ImPointRight} from 'react-icons/im'
import {FaGamepad, FaTv, FaPlane} from 'react-icons/fa'

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{textAlign: 'justify'}}>
            Hi Everyone, I am <span className="purple">Amaan Akbany </span>
            from <span className="purple"> Gujarat, India.</span>
            <br />I am a Software Developer.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <FaGamepad /> Playing Games
            </li>
            <li className="about-activity">
              <FaPlane /> Travelling
            </li>
            <li className="about-activity">
              <FaTv /> Watching Movies and Web Series
            </li>
          </ul>

          <p style={{marginBlockEnd: 0, color: 'rgb(155 126 172)'}}>
          "The only way to learn a new programming language is by writing programs in it."{' '}
          </p>
          <p></p>
          <footer className="blockquote-footer">Dennis Ritchie</footer>
        </blockquote>
      </Card.Body>
    </Card>
  )
}

export default AboutCard
